// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_wkt__Google_protobuf_timestamp from "../../third_party/google_wkt/gen/google_protobuf_timestamp.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_prop_information.ml",
      79,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "PropInformation"
                    ]]
                },
                "V1alpha1"
              ]]
          },
          "Control"
        ]]
    });

const Control = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_prop_information.ml",
      121,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "PropInformation"
              ]]
          },
          "V1alpha1"
        ]]
    });

const V1alpha1 = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_prop_information.ml",
      161,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "PropInformation"
        ]]
    });

const PropInformation = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_prop_information.ml",
      197,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.control.v1alpha1.PropInformation";
}

function make(idOpt, nameOpt, addressOpt, residentOpt, emailOpt, phoneOpt, create_time, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  const name = nameOpt !== undefined ? nameOpt : "";
  const address = addressOpt !== undefined ? addressOpt : "";
  const resident = residentOpt !== undefined ? residentOpt : false;
  const email = emailOpt !== undefined ? emailOpt : "";
  const phone = phoneOpt !== undefined ? phoneOpt : "";
  return {
          id: id,
          name: name,
          address: address,
          resident: resident,
          email: email,
          phone: phone,
          create_time: create_time
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "name",
            "name"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_address = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "address",
            "address"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_resident = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            5,
            "resident",
            "resident"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

const merge_email = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            7,
            "email",
            "email"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_phone = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            8,
            "phone",
            "phone"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_create_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            50,
            "create_time",
            "createTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge(t1, t2) {
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          name: Curry._2(merge_name, t1.name, t2.name),
          address: Curry._2(merge_address, t1.address, t2.address),
          resident: Curry._2(merge_resident, t1.resident, t2.resident),
          email: Curry._2(merge_email, t1.email, t2.email),
          phone: Curry._2(merge_phone, t1.phone, t2.phone),
          create_time: Curry._2(merge_create_time, t1.create_time, t2.create_time)
        };
}

function spec(param) {
  const $$let = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "name",
                        "name"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "address",
                            "address"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                5,
                                "resident",
                                "resident"
                              ],
                              Ocaml_protoc_plugin__Spec.bool,
                              false
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                  [
                                    7,
                                    "email",
                                    "email"
                                  ],
                                  Ocaml_protoc_plugin__Spec.string,
                                  ""
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                      [
                                        8,
                                        "phone",
                                        "phone"
                                      ],
                                      Ocaml_protoc_plugin__Spec.string,
                                      ""
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                          [
                                            50,
                                            "create_time",
                                            "createTime"
                                          ],
                                          Ocaml_protoc_plugin__Spec.message({
                                                name: $$let.name,
                                                make: $$let.make,
                                                from_proto: $$let.from_proto,
                                                from_proto_exn: $$let.from_proto_exn,
                                                to_proto: $$let.to_proto,
                                                to_proto$p: $$let.to_proto$p,
                                                merge: $$let.merge,
                                                to_json: $$let.to_json,
                                                from_json_exn: $$let.from_json_exn,
                                                from_json: $$let.from_json
                                              })
                                        ]), Ocaml_protoc_plugin__Spec.nil)))))));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._8(serialize, writer, param.id, param.name, param.address, param.resident, param.email, param.phone, param.create_time);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, name, address, resident, email, phone, create_time) {
  return {
          id: id,
          name: name,
          address: address,
          resident: resident,
          email: email,
          phone: phone,
          create_time: create_time
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.PropInformation", spec(undefined))(options);
  return function (param) {
    return Curry._7(serialize, param.id, param.name, param.address, param.resident, param.email, param.phone, param.create_time);
  };
}

function constructor$1(id, name, address, resident, email, phone, create_time) {
  return {
          id: id,
          name: name,
          address: address,
          resident: resident,
          email: email,
          phone: phone,
          create_time: create_time
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.PropInformation", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, PropInformation, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "PropInformation"
        ]]
    }, V1alpha1, {
      PropInformation: PropInformation
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "PropInformation"
              ]]
          },
          "V1alpha1"
        ]]
    }, Control, {
      V1alpha1: V1alpha1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "PropInformation"
                    ]]
                },
                "V1alpha1"
              ]]
          },
          "Control"
        ]]
    }, Buhta, {
      Control: Control
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
